import CompleteSendEmail from '../../../../auth/cast/completeSendEmail';
const CastCompleteChangePassword = () => {
  return <CompleteSendEmail changePassword={true} />;
};
export default CastCompleteChangePassword;
